import actionTypes from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RETAILER_DETAILS_SUCCESS:
      return { ...action.details };
    case actionTypes.CLEAR_RETAILER_DETAILS:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/retailer-details.reducer.js